import { PageTitle, PageContainer, FloatBox, Heading, useHead } from '@mybonus/ui';

import {
	Content,
	Illustration,
	ContentSection,
	$CmsContent,
	TopContent,
} from './HowItWorksView.parts';

const title = 'Så funkar det';

export function HowItWorksView() {
	useHead({ subtitle: title });

	return (
		<PageContainer noTopSpace>
			<PageTitle>
				<Heading level={1}>{title}</Heading>
			</PageTitle>

			<FloatBox>
				<Content>
					<TopContent />

					<ContentSection>
						<Illustration uri="/assets/images/dude-hammock.svg" />
						<$CmsContent code="howitworks_1" />
					</ContentSection>

					<ContentSection flipped>
						<$CmsContent code="howitworks_2" />
						<Illustration uri="/assets/images/bullish-trumpet.svg" />
					</ContentSection>

					<ContentSection>
						<Illustration uri="/assets/images/chasing-pig.svg" />
						<$CmsContent code="howitworks_3" />
					</ContentSection>

					<ContentSection flipped>
						<$CmsContent code="howitworks_4" />
						<Illustration uri="/assets/images/group-of-friends.svg" />
					</ContentSection>
				</Content>
			</FloatBox>
		</PageContainer>
	);
}
